export const LOGIN_RETURN_URL = `login_return_url`;
export const LOGIN_LANGUAGE = `login_language`;
export const ACCESS_TOKEN_KEY = `access_token`;
export const STORAGE_TENANT_KEY = `softools-tenant`;
export const QUERY_STR_TENANT_KEY = `softools_tenant`;
export const HEADER_TENANT_KEY = STORAGE_TENANT_KEY;
export const ASSETS_TOKEN_KEY = `auth_token`;
